import React, { FC } from 'react'
import { Form, Input as AntdInput } from 'antd'
import { FieldProps, getIn } from 'formik'
import { InputProps } from 'antd/lib/input'

type Props = FieldProps & InputProps

const Input: FC<Props> = ({
  field,
  form: { errors, touched, setFieldValue, setFieldTouched },
  ...restProps
}) => {
  return (
    <Form.Item
      hasFeedback
      help={
        getIn(touched, field.name) && getIn(errors, field.name)
          ? getIn(errors, field.name)
          : ''
      }
      validateStatus={
        getIn(touched, field.name)
          ? getIn(errors, field.name)
            ? 'error'
            : 'success'
          : ''
      }
    >
      <AntdInput
        {...field}
        {...restProps}
        onChange={e => {
          setFieldTouched(field.name, true)
          setFieldValue(field.name, e.target.value)
        }}
        onBlur={() => setFieldTouched(field.name, true)}
        value={field.value}
      />
    </Form.Item>
  )
}

export default Input
